import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchAdminDashboard } from '../../store/slices/dashboardSlice';
import { StatCard } from './StatCard';
import { useNavigate } from 'react-router-dom';

export const AdminDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { adminDashboard, loading, error } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    dispatch(fetchAdminDashboard());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-600 dark:text-gray-400">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
        <p className="text-red-700 dark:text-red-300">{error}</p>
      </div>
    );
  }

  if (!adminDashboard) {
    return null;
  }

  return (
    <div className="space-y-6 animate-fadeIn">
      {/* Acil İşlemler - Büyük Kart */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="animate-slideUp" style={{ animationDelay: '0ms' }}>
          <StatCard
            title="Onay Bekleyen Talepler"
            value={adminDashboard.pendingApprovalRequests}
            icon={<i className="fas fa-exclamation-triangle"></i>}
            color="red"
            onClick={() => navigate('/request-evaluation')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '100ms' }}>
          <StatCard
            title="Toplam Kullanıcılar"
            value={adminDashboard.totalUsers}
            icon={<i className="fas fa-users"></i>}
            color="blue"
          />
        </div>
      </div>

      {/* Genel İstatistikler */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="animate-slideUp" style={{ animationDelay: '200ms' }}>
          <StatCard
            title="Toplam Talepler"
            value={adminDashboard.totalRequests}
            icon={<i className="fas fa-file-alt"></i>}
            color="blue"
            onClick={() => navigate('/request-evaluation')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '300ms' }}>
          <StatCard
            title="Onaylanan Talepler"
            value={adminDashboard.approvedRequests}
            icon={<i className="fas fa-check-circle"></i>}
            color="green"
            onClick={() => navigate('/request-tracking?status=Approved')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '400ms' }}>
          <StatCard
            title="Reddedilen Talepler"
            value={adminDashboard.rejectedRequests}
            icon={<i className="fas fa-times-circle"></i>}
            color="red"
            onClick={() => navigate('/request-tracking?status=Rejected')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '500ms' }}>
          <StatCard
            title="Aktif Tedarikçiler"
            value={adminDashboard.activeSuppliers}
            icon={<i className="fas fa-truck"></i>}
            color="blue"
          />
        </div>
      </div>

      {/* Son Aktiviteler */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="animate-slideUp" style={{ animationDelay: '600ms' }}>
          <StatCard
            title="Son 7 Gün Talepler"
            value={adminDashboard.recentRequests}
            icon={<i className="fas fa-calendar-alt"></i>}
            color="blue"
            onClick={() => navigate('/request-tracking?days=7')}
          />
        </div>
        <div className="animate-slideUp" style={{ animationDelay: '700ms' }}>
          <StatCard
            title="Son 7 Gün Onaylanan"
            value={adminDashboard.recentApprovedRequests}
            icon={<i className="fas fa-check-double"></i>}
            color="green"
            onClick={() => navigate('/request-tracking?days=7&status=Approved')}
          />
        </div>
      </div>
    </div>
  );
};
